import React from "react"

export const SubmitButton = ({ label }) => {
  return <input type="submit" data-type="button" value={label || "Submit"} />
}

export const Row = props => (
  <div style={{ clear: "both" }}>{props.children}</div>
)
